"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCheckIntegrationsAvailability = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _reactRedux = require("react-redux");

var _gift = require("../store/gift/gift.actions");

var _gift2 = require("../store/gift/gift.selector");

var useCheckIntegrationsAvailability = function useCheckIntegrationsAvailability(linkToIntegration) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var giftId = (0, _reactRedux.useSelector)(_gift2.getGiftId);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isReadyToCheck = _useState2[0],
      setReadyToCheck = _useState2[1];

  var toggleReadyToCheck = (0, _react.useCallback)(function (isReady) {
    return setReadyToCheck(isReady);
  }, []);
  var onWindowFocus = (0, _react.useCallback)(function () {
    if (linkToIntegration && giftId && isReadyToCheck) {
      dispatch((0, _gift.giftLoadRequest)(giftId));
      setReadyToCheck(false);
    }
  }, [dispatch, giftId, linkToIntegration, isReadyToCheck]);
  (0, _react.useEffect)(function () {
    window.addEventListener('focus', onWindowFocus);
    return function () {
      window.removeEventListener('focus', onWindowFocus);
    };
  }, [onWindowFocus]);
  return toggleReadyToCheck;
};

exports.useCheckIntegrationsAvailability = useCheckIntegrationsAvailability;